/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gyms_Delete_BodyInputs */

const en_us2_gyms_delete_body = /** @type {(inputs: Gyms_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only the saved list goes. The equipment in effect stays as it is.`)
};

const pt_br2_gyms_delete_body = /** @type {(inputs: Gyms_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só a lista salva sai. Os equipamentos em uso continuam como estão.`)
};

const es_419_gyms_delete_body = /** @type {(inputs: Gyms_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo se borra la lista guardada. El equipo en uso queda como está.`)
};

const pt_pt2_gyms_delete_body = /** @type {(inputs: Gyms_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só sai a lista guardada. O equipamento em uso fica como está.`)
};

const fr_fr2_gyms_delete_body = /** @type {(inputs: Gyms_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seule la liste enregistrée disparaît. L'équipement actif reste tel quel.`)
};

const de_de2_gyms_delete_body = /** @type {(inputs: Gyms_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur die gespeicherte Liste wird entfernt. Die aktive Ausstattung bleibt, wie sie ist.`)
};

const it_it2_gyms_delete_body = /** @type {(inputs: Gyms_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sparisce solo la lista salvata. L'attrezzatura in uso resta com'è.`)
};

/**
* | output |
* | --- |
* | "Only the saved list goes. The equipment in effect stays as it is." |
*
* @param {Gyms_Delete_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gyms_delete_body = /** @type {((inputs?: Gyms_Delete_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gyms_Delete_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gyms_delete_body(inputs)
	if (locale === "es-419") return es_419_gyms_delete_body(inputs)
	if (locale === "pt-PT") return pt_pt2_gyms_delete_body(inputs)
	if (locale === "fr-FR") return fr_fr2_gyms_delete_body(inputs)
	if (locale === "de-DE") return de_de2_gyms_delete_body(inputs)
	if (locale === "it-IT") return it_it2_gyms_delete_body(inputs)
	return en_us2_gyms_delete_body(inputs)
});
export { gyms_delete_body as "gyms.delete_body" }